import React from 'react';
import createArtistListRoute from '../utils/artist-list-page';
import ArtistListPage from '../components/common/ArtistListPage';

import {
  selectConductorsIsLoading,
  selectNextConductorsCursor,
  selectPrevConductorsCursor,
  selectConductors,
} from '../selectors/conductor';
import * as conductorActions from '../actions/conductor';

const route = createArtistListRoute({
  artistType: 'conductors',
  selectItems: selectConductors,
  selectIsLoading: selectConductorsIsLoading,
  selectNextCursor: selectNextConductorsCursor,
  selectPrevCursor: selectPrevConductorsCursor,
  loadAction: conductorActions.loadConductors,
});

const Conductors = ({ ...props }) => {
  return <ArtistListPage {...props} />;
};

Conductors.onDataFetch = route.onDataFetch;

export default route(Conductors);
